/*
Author : Raphaël Dardeau


Markup : 

<meta property="og:title" content="Lorem ipsum">
<input type="text" name="title" data-binding="meta[property='og:title']" value />


Setup : 

$(function() {
	$(document).databinding();
});
*/
;(function ( $, window, document, undefined ) {
    var pluginName = "databinding",
        defaults = {
			interval:1000,
			formElements: ['INPUT', 'SELECT', 'TEXTAREA']
		};		

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
        	setInterval($.proxy(function() {
        		this.setElements();
        		this.setDatas();
        	}, this), this.settings.interval);
        },

        setElements: function() {
			this.$elements = $("[data-binding]");
		},
		
        setDatas: function() {
			if (this.$elements.length) {
				var _this = this;
				this.$elements.each(function (i) {
					var $sourceElement = $($(this).data("binding"));
					if ($sourceElement.length) {
						var sourceTag = $sourceElement.prop("tagName");
						if ($.inArray(sourceTag, _this.settings.formElements) != -1)
							var sourceValue = $sourceElement.val();
						else if (sourceTag == "META")
							var sourceValue = $sourceElement.attr("content");
						else if (sourceTag == "FORM")
							var sourceValue = $sourceElement.attr("action");
						else
							var sourceValue = $sourceElement.text();

						var elementTag = $(this).prop("tagName");
						if ($.inArray(elementTag, _this.settings.formElements) != -1)
							$(this).val(sourceValue);
						else if (elementTag == "META")
							$(this).attr("content", sourceValue);
						else if (elementTag == "FORM")
							$(this).attr("action", sourceValue);
						else
							$(this).text(sourceValue);
					}
				});
			}
		}

    });

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );